import { z } from 'zod';
import { requiredString } from '../helpers';
/**
 * eGain Check Chat Allowed v1 Configuration Validator
 * Validates eGain chat allowed check configuration
 */
export const Egain_Check_Chat_Allowed_1_ConfigValidator = z.object({
    connection: requiredString('eGain Connection is required'),
    entryPointId: requiredString('Entry Point ID is required')
});
//# sourceMappingURL=egain-check-chat-allowed-1.js.map